import Config from "../config/constants";
import axios, { AxiosResponse } from 'axios';

export const apiGetUsers = async (page: number, limit: number, accessToken: string, searchcond?: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/user/userlist`;

    try {
        const response = await axios.get(url, { params: {page, limit, searchcond }, headers: {
            access_token: accessToken
        }});
        
        return response.data; // Adjust based on your API's response structure
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; // Handle or propagate the error
    }
};

export const apiPatchUser = async (params: any, id: number, accessToken: string) => {
    const url = `${Config.API_HOST}/api/admin/user/${id}`;
    console.log(url);
    try {
      const response = await axios.patch(url, params, {
        headers: { access_token: accessToken }
    }); // 수정된 부분
      return response.data; // Adjust based on your API's response structure
    } catch (error) {
      console.error('Error updating user:', error);
      throw error; // Handle or propagate the error
    }
};

export const apiExcelUser = async (accessToken: string, searchcond?: string) => {
    let url = `${Config.API_HOST}/api/admin/user/export-excel`;
    
    // 검색 조건이 있으면 쿼리 파라미터로 추가
    if (searchcond) {
        url += `?searchcond=${encodeURIComponent(searchcond)}`;
    }
    
    try {
        const response = await axios.get(url, { 
            headers: { access_token: accessToken },
            responseType: 'blob' // 바이너리 데이터로 받기 위해 필요
        });
        return response.data;
    } catch (error) {
        console.error('Excel 다운로드 중 오류 발생:', error);
        throw error;
    }
};


  /*
export const apiGetUser = async (userid: string): Promise<AxiosResponse> => {
    const url = `${Config.API_HOST}/api/admin/user/userlist`;
    
    try {
        const response = await axios.get(url, {
            params: {
                userid      
            }
        });
        return response.data; // Adjust based on your API's response structure
    } catch (error) {
        console.error('Error fetching users:', error);
        throw error; // Handle or propagate the error
    }
};
*/

/**
 * 회원 삭제. 서버는 **softDelete** 다 — 행이 사라지지 않고 `deletedAt` 이 채워진다.
 * 목록과 앱에서는 안 보이지만 DB 에는 남으므로 `deletedAt` 을 비우면 되살아난다.
 */
export const apiDeleteUser = async (id: number, accessToken: string) => {
  const url = `${Config.API_HOST}/api/admin/user/${id}`;
  try {
    const response = await axios.delete(url, {
      headers: { access_token: accessToken },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting 회원:', error);
    throw error;
  }
};
